import { render, staticRenderFns } from "./projectDrawer.vue?vue&type=template&id=65d6553d&scoped=true&"
import script from "./projectDrawer.vue?vue&type=script&lang=js&"
export * from "./projectDrawer.vue?vue&type=script&lang=js&"
import style0 from "./projectDrawer.vue?vue&type=style&index=0&id=65d6553d&scoped=true&lang=css&"
import style1 from "./projectDrawer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6553d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d6553d')) {
      api.createRecord('65d6553d', component.options)
    } else {
      api.reload('65d6553d', component.options)
    }
    module.hot.accept("./projectDrawer.vue?vue&type=template&id=65d6553d&scoped=true&", function () {
      api.rerender('65d6553d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drawers/projectDrawer.vue"
export default component.exports